import { EntityStatus, ServiceActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get all service api
 * @returns Array of objects as required by service table
 */
export const convertServiceList = (data) => {
  const list = data.services ? data.services : [];
  return list.map((serv) => {
    return {
      key: serv.serviceid,
      serviceId: serv.serviceid,
      name: serv.servicename,
      dispName: serv.displayname,
      type: serv.servicetype,
      status: serv.servicestatus,
      deployment: serv.deployment,
      maturity: serv.servicedetails?.maturitystate,
      location: serv.servicedetails?.location?.locationURL,
      version: serv.servicedetails?.version,
    };
  });
};

/**
 * @param {*} data : service form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertServiceFormToApiValues = (
  data,
  action = ServiceActions.add
) => {
  const returnData = {
    servicetype: data.type,
    displayname: data.dispName,
    deployment: data.deployment,
  };

  if (action === ServiceActions.add) {
    returnData.servicename = data.name;
    returnData.servicestatus = EntityStatus.ACTIVE;
  }
  if (action === ServiceActions.edit) {
    returnData.serviceid = data.id;
  }
  return returnData;
};

/**
 * @param {*} data : reponse from get service dependency api
 * @returns Array of objects containing key and name
 */
export const convertServiceDependencyApiToList = (data) => {
  const list = data.dependentservices ? data.dependentservices : [];
  return list.map((item) => {
    return {
      serviceId: item.serviceid,
      name: item.servicename,
    };
  });
};

/**
 * @param {*} data : Array of service ids selected for adding
 * @returns Object formatted as required by update service dependencies api
 */
export const convertServiceDependencyListToApi = (data) => {
  const returnData = { dependentservices: [] };
  data.forEach((servId) => {
    returnData.dependentservices.push({ serviceid: servId });
  });
  return returnData;
};

/**
 * @param {*} data : response from get service api for some parent id
 * @returns Array of objects as required by simple service list
 */
export const convertServiceSimpleList = (data) => {
  const list = data.services ? data.services : [];
  return list.map((item) => {
    return {
      serviceId: item.serviceid,
      serviceName: item.servicename,
    };
  });
};
